const buttonStyles = {
  'elm-button': 'block font-bold w-full cursor-pointer hover:from-elm hover:to-elm-darken bg-linear-to-b from-teal from-0% to-100% to-elm shadow-m7 shadow-cyprus/50 text-white p-3 text-center rounded-lg',
};

export default buttonStyles;
